import type { PolygonArea } from "./types";

// Shoelace formula
export const polygonArea: PolygonArea = (points) => {
  let doubledArea = 0;
  for (let index = 0; index < points.length; index += 1) {
    const point = points[index];
    const next = points[(index + 1) % points.length];
    doubledArea += point.x * next.y - next.x * point.y;
  }
  return Math.abs(doubledArea) / 2;
};
